import { createGlobalStyle } from 'styled-components'

export const Global = createGlobalStyle`
  html {
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
  }

  body {
    overscroll-behavior: none;
    background-color: ${({ theme }) => theme.color.background};
    color: ${({ theme }) => theme.color.gray[900]};
    font-size: 16px;
    margin: 0;
    font-family: ${({ theme }) => theme.typeface.sans};
  }

  h1, h2, h3, h4, h5, h6, p, ul, li {
    margin: 0;
  }

  label {
    cursor: default;
  }

  input, button, select, textarea {
    -webkit-appearance: none;
    outline: none;
    font-family: ${({ theme }) => theme.typeface.sans};
    margin: 0;
    padding: 0;
    font-size: 16px;
    border: 0;
  }

  input::placeholder {
    color: ${({ theme }) => theme.color.gray[500]};
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type=number] {
    -moz-appearance: textfield;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover, 
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 1000px ${({ theme }) => theme.color.foreground}10 inset;
    box-shadow: 0 0 0px 1000px ${({ theme }) => theme.color.foreground}10 inset;
    transition: background-color 5000s ease-in-out 0s;
    color: ${({ theme }) => theme.color.foreground};
    -webkit-text-fill-color: ${({ theme }) => theme.color.foreground};
  }

  input:-webkit-autofill::first-line {
    font-family: ${({ theme }) => theme.typeface.sans};
    font-size: 16px !important;
    color: ${({ theme }) => theme.color.foreground};
  }

  button:hover, a:hover {
    cursor: pointer;
  }

  button, a {
    user-select: none;
  }

  .confetti {
    position: fixed;
    top: -250px;
    left: 50%;
    pointer-events: none;
    transform: translateX(-50%);
    z-index: 9999999;
  }
`
